import api from './api';

/**
 * Analyst Service
 * Handles all analyst-specific API calls
 */
export const analystService = {
  // ==================== Dashboard ====================
  
  /**
   * Get analyst dashboard
   */
  async getDashboard() {
    return api.get('/analyst/dashboard');
  },

  // ==================== Profile ====================
  
  /**
   * Get analyst profile
   */
  async getProfile(userId) {
    return api.get(`/analyst/profile/${userId}`);
  },

  /**
   * Update analyst profile
   */
  async updateProfile(profileData) {
    return api.put('/analyst/profile', profileData);
  },

  // ==================== Research Reports ====================
  
  /**
   * Get all research reports
   */
  async getResearchReports(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/analyst/research-reports?${queryString}`);
  },

  /**
   * Get research report by ID
   */
  async getResearchReport(id) {
    return api.get(`/analyst/research-reports/${id}`);
  },

  /**
   * Create research report
   */
  async createResearchReport(reportData) {
    return api.post('/analyst/research-reports', reportData);
  },

  /**
   * Update research report
   */
  async updateResearchReport(id, reportData) {
    return api.put(`/analyst/research-reports/${id}`, reportData);
  },

  /**
   * Publish research report
   */
  async publishResearchReport(id) {
    return api.post(`/analyst/research-reports/${id}/publish`);
  },

  /**
   * Delete research report
   */
  async deleteResearchReport(id) {
    return api.delete(`/analyst/research-reports/${id}`);
  },

  // ==================== Recommendations ====================
  
  /**
   * Get all recommendations
   */
  async getRecommendations(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/analyst/recommendations?${queryString}`);
  },

  /**
   * Create recommendation
   */
  async createRecommendation(recommendationData) {
    return api.post('/analyst/recommendations', recommendationData);
  },

  /**
   * Update recommendation
   */
  async updateRecommendation(id, recommendationData) {
    return api.put(`/analyst/recommendations/${id}`, recommendationData);
  },

  /**
   * Delete recommendation
   */
  async deleteRecommendation(id) {
    return api.delete(`/analyst/recommendations/${id}`);
  },

  // ==================== Coverage ====================
  
  /**
   * Get coverage list
   */
  async getCoverageList() {
    return api.get('/analyst/coverage');
  },

  /**
   * Add to coverage
   */
  async addToCoverage(data) {
    return api.post('/analyst/coverage', data);
  },

  /**
   * Remove from coverage
   */
  async removeFromCoverage(id) {
    return api.delete(`/analyst/coverage/${id}`);
  },

  // ==================== Clients ====================
  
  /**
   * Get connected clients (investors)
   */
  async getClients(userId) {
    return api.get(`/analyst/clients/${userId}`);
  },

  /**
   * Search for potential clients
   */
  async searchClients(searchParams) {
    const queryString = new URLSearchParams(searchParams).toString();
    return api.get(`/analyst/clients/search?${queryString}`);
  },

  /**
   * Get connected analysts for an investor
   */
  async getConnectedAnalysts(userId) {
    return api.get(`/analyst/connected/${userId}`);
  },

  /**
   * Get connected or engaged analysts for an investor
   */
  async getConnectedOrEngagedAnalysts(userId) {
    return api.get(`/analyst/connected-engaged/${userId}`);
  },
};

export default analystService;
